import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=88d1754a&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=88d1754a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d1754a",
  null
  
)

export default component.exports